import { JsonDataType } from "../../../../../utils";
import { Document, FileAttachment, Location, DocumentSchedulingRequest } from "../../../../../models";

export interface UpdateDocumentAdditionalData {
    docId: string,
    updateInfo?: DocumentUpdateInfo
}

export interface DocumentAddRelatedUpdateAdditionalData {
    docId: string,
    updateInfo?: DocumentAddRelatedUpdate
}

export type DocumentUpdateInfo = DocumentFieldUpdate | DocumentChecklistTitleUpdate | DocumentArticleWysiwygUpdate
    | DocumentAddRelatedUpdate | DocumentAddFileAttachment | DocumentLocationUpdate | DocumentSchedulingUpdate
    | DocumentPreviewImageUpdate | DocumentDeleteFileAttachment

export const DOCUMENT_FIELD_UPDATE = 'DOCUMENT_FIELD_UPDATE'
export interface DocumentFieldUpdate {
    type: typeof DOCUMENT_FIELD_UPDATE
    data: JsonDataType
}


export const DOCUMENT_ARTICLE_WYSIWYG_UPDATE = 'DOCUMENT_ARTICLE_WYSIWYG_UPDATE'
export interface DocumentArticleWysiwygUpdate {
    type: typeof DOCUMENT_ARTICLE_WYSIWYG_UPDATE
    html: string
}

export const DOCUMENT_LOCATION_UPDATE = 'DOCUMENT_LOCATION_UPDATE'
export interface DocumentLocationUpdate {
    type: typeof DOCUMENT_LOCATION_UPDATE
    data: Location | null
}


export const DOCUMENT_PREVIEW_IMAGE_UPDATE = 'DOCUMENT_PREVIEW_IMAGE_UPDATE'
export interface DocumentPreviewImageUpdate {
    type: typeof DOCUMENT_PREVIEW_IMAGE_UPDATE
    previewImgUrl: string
}



export const DOCUMENT_SCHEDULING_UPDATE = 'DOCUMENT_SCHEDULING_UPDATE'
export interface DocumentSchedulingUpdate {
    type: typeof DOCUMENT_SCHEDULING_UPDATE
    data: DocumentSchedulingRequest | null
}

export const DOCUMENT_CHECKLIST_TITLE_UPDATE = 'DOCUMENT_CHECKLIST_TITLE_UPDATE'
export interface DocumentChecklistTitleUpdate {
    type: typeof DOCUMENT_CHECKLIST_TITLE_UPDATE
    checklistUid: string
}

export const DOCUMENT_ADD_RELATED_UPDATE = 'DOCUMENT_ADD_RELATED_UPDATE'
export interface DocumentAddRelatedUpdate {
    type: typeof DOCUMENT_ADD_RELATED_UPDATE
    linkId: string
    linkedDocument?: Document
}

export const DOCUMENT_ADD_FILE_ATTACHMENT = 'DOCUMENT_ADD_FILE_ATTACHMENT'
export interface DocumentAddFileAttachment {
    type: typeof DOCUMENT_ADD_FILE_ATTACHMENT
    attachments: FileAttachment[]
}

export const DOCUMENT_DELETE_FILE_ATTACHMENT = 'DOCUMENT_DELETE_FILE_ATTACHMENT'
export interface DocumentDeleteFileAttachment {
    type: typeof DOCUMENT_DELETE_FILE_ATTACHMENT
    attachments: FileAttachment[]
}